import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop'; 
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InsertMarcaComponent } from './insertMarca/insertMarca.component';
import { ImageInputComponent } from './imageInput/imageInput.component';
import { HomeComponent } from './home/home.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { SelectorComponent } from './selector/selector.component';
import { ContactusComponent } from './contactus/contactus.component';
import { LoginComponent } from './login/login.component';
import { TermsComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ResponsabilityComponent } from './responsability/responsability.component';
import { ClockComponent } from './clock/clock.component';
import { AdminComponent } from './admin/admin.component';
import { InsertProductComponent } from './insertProduct/insertProduct.component';
import { InsertNewsComponent } from './InsertNews/InsertNews.component';
import { InsertCarouselComponent } from './insertCarousel/insertCarousel.component';
import { JoiaComponent } from './joia/joia.component';
import { SomosComponent } from './somos/somos.component';
import { RegisterComponent } from './register/register.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { MarcaComponent } from './marca/marca.component';
import { InsertDestaquesComponent } from './insertDestaques/insertDestaques.component';
import { ModeloComponent } from './modelo/modelo.component';
import { CarecteristicasComponent } from './Carecteristicas/Carecteristicas.component';
import { SinglenewsComponent } from './singlenews/singlenews.component';
import { RecoveryComponent } from './recovery/recovery.component';
import { ContrastariaComponent } from './contrastaria/contrastaria.component';
import { EmailRecoveryComponent } from './emailRecovery/emailRecovery.component';
import { NoivasComponent } from './noivas/noivas.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ProdutosComponent } from './produtos/produtos.component';
import { NoticiasComponent } from './noticias/noticias.component';
import { MatrixPipe } from './_pipes/matrix.pipe';
import { SliderComponent } from './slider/slider.component';
import { PasswordComponent } from './password/password.component';
import { AcessoriosComponent } from './acessorios/acessorios.component';
import { BacktoadminComponent } from './backtoadmin/backtoadmin.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GestaoComponent } from './gestao/gestao.component';
import { GestaoAltaRelojoariaComponent } from './GestaoaltaRelojoaria/altaRelojoaria.component';
import { GestaoRelojoariaComponent } from './Gestaorelojoaria/relojoaria.component';
import { GestaoJoiasComponent } from './Gestaojoias/joias.component';
import { GestaoNoivasComponent } from './gestaoNoivas/gestaoNoivas.component';
import { GestaoAcessoriosComponent } from './gestaoAcessorios/gestaoAcessorios.component';
import { GestaoPratasComponent } from './gestaoPratas/gestaoPratas.component';
import { GestaoMarcasComponent } from './gestaoMarcas/gestaoMarcas.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({ declarations: [
        AppComponent,
        InsertMarcaComponent,
        ImageInputComponent,
        HomeComponent,
        NavbarComponent,
        FooterComponent,
        SelectorComponent,
        ContactusComponent,
        LoginComponent,
        LoginComponent,
        TermsComponent,
        PrivacyComponent,
        ResponsabilityComponent,
        ClockComponent,
        AdminComponent,
        InsertProductComponent,
        InsertNewsComponent,
        InsertCarouselComponent,
        JoiaComponent,
        SomosComponent,
        RegisterComponent,
        BreadcrumbComponent,
        MarcaComponent,
        InsertDestaquesComponent,
        ModeloComponent,
        CarecteristicasComponent,
        SinglenewsComponent,
        RecoveryComponent,
        ContrastariaComponent,
        EmailRecoveryComponent,
        NoivasComponent,
        PaginationComponent,
        ProdutosComponent,
        NoticiasComponent,
        MatrixPipe,
        SliderComponent,
        PasswordComponent,
        AcessoriosComponent,
        BacktoadminComponent,
        GestaoComponent,
        GestaoAltaRelojoariaComponent,
        GestaoRelojoariaComponent,
        GestaoJoiasComponent,
        GestaoNoivasComponent,
        GestaoAcessoriosComponent,
        GestaoPratasComponent,
        GestaoMarcasComponent
    ],
    bootstrap: [AppComponent], imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        FontAwesomeModule,
        SweetAlert2Module.forRoot(),
        BrowserAnimationsModule,
        DragDropModule], providers: [
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
